import { Autocomplete, Box, Button, TextField } from '@mui/material';
import ConsultantAutoComplete from '@src/components/consultant/ConsutlantAutoComplete';
import ProcedureAutoComplete from '@src/components/procedure/ProcedureAutoComplete';
import ScanCheckDecisionDTO from '@src/adapters/dto/scan/ScanCheckDecisionDTO';
import { ScanCheckDecisionType } from '@src/constants/ScanCheckDecisionType';

interface Props {
  consultantId: string | null;
  procedureId: string | null;
  selectedOptionId: ScanCheckDecisionType;
  consultantSelected(consultantId: string | null): void;
  procedureSelected(procedureId: string | null): void;
  saveAndNext(): void;
  setSelectedOption(option: ScanCheckDecisionDTO): void;
}

const options: ScanCheckDecisionDTO[] = [
  { label: 'Preference Card', id: ScanCheckDecisionType.CardItem },
  {
    label: 'Consultant Document',
    id: ScanCheckDecisionType.ConsultantItem,
  },
  { label: 'Do Not Migrate', id: ScanCheckDecisionType.DoNotMigrate },
];
function Header({
  consultantId,
  procedureId,
  selectedOptionId,
  consultantSelected,
  setSelectedOption,
  procedureSelected,
  saveAndNext,
}: Props) {
  const selectedOption = options.find(
    (option) => option.id === selectedOptionId
  );

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        backgroundColor: '#fff',
        padding: theme.spacing(2),
        height: theme.spacing(10),
      })}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-evenly',
        }}>
        <Box sx={{ width: '30%' }}>
          <Autocomplete
            disablePortal
            disableClearable
            value={selectedOption}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={options}
            sx={{ width: 300 }}
            onChange={(event, value) => setSelectedOption(value)}
            renderInput={(params) => <TextField {...params} label="Decision" />}
          />
        </Box>
        <Box sx={{ display: 'flex', width: '65%' }}>
          <Box
            sx={(theme) => ({ width: '40%', paddingRight: theme.spacing(2) })}>
            <ConsultantAutoComplete
              onSelection={(id) => consultantSelected(id)}
              selectedId={consultantId}
              enableNew={true}
            />
          </Box>
          <Box sx={{ width: '60%' }}>
            <ProcedureAutoComplete
              onSelection={(id) => procedureSelected(id)}
              selectedId={procedureId}
              enableNew={true}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'right',
            width: '35%',
          }}>
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={saveAndNext}>
            Save and Next
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Header;
